import { useCallback } from "react";
import { useCalendlyAdapterAxiosInstance } from "./useCalendlyAdapterAxiosInstance.ts";

import { useWithLoading } from "../UI/Loading/useWithLoading.ts";
export type AvailableUserDTO = {
  email: string;
  uri: string;
};

export function useGetCalendlyUsers() {
  const axiosInstance = useCalendlyAdapterAxiosInstance();
  const { withLoading, loading } = useWithLoading<AvailableUserDTO[]>();
  const getCalendlyUsersCall = useCallback(async () => {
    const { data } = await axiosInstance.get<AvailableUserDTO[]>(`/users/`);

    return data;
  }, [axiosInstance]);

  const getCalendlyUsers = useCallback(async () => {
    return await withLoading(() => getCalendlyUsersCall());
  }, [withLoading, getCalendlyUsersCall]);

  return {
    getCalendlyUsers,
    loading,
  };
}
